export default {
  'trucker-admin-id-vehicle-category': ['vehicle_category_management'],
  'trucker-admin-id-business-task': ['task_management'],
  'trucker-admin-id-business': ['business_management'],
  'trucker-admin-id-node-list': ['node_management'],
  'trucker-admin-id-node-location': ['node_location_management'],
  'trucker-admin-id-node-type': ['node_type_management'],
  'trucker-admin-id-workflow': ['workflow_management']
}
